(function () {
  'use strict';

  var popup    = document.getElementById('search-popup');
  var overlay  = popup ? popup.querySelector('.search-popup__overlay') : null;
  var input    = document.getElementById('search-input');
  var submit   = document.getElementById('search-submit');
  var closeBtn = document.getElementById('search-close');
  var clearBtn = document.getElementById('search-clear');
  var results  = document.getElementById('search-results');
  var openBtn  = document.getElementById('search-open');
  var defaultRecentHTML = results ? results.innerHTML : '';
  var closeLabel = closeBtn ? closeBtn.querySelector('.search-popup__close-label') : null;

  if (!popup || !input) return;

  var debounceTimer = null;
  var currentQuery  = '';

  // localStorage helpers for Recent Searches
  function getRecentSearches() {
    try {
      var recent = localStorage.getItem('recentSearches');
      return recent ? JSON.parse(recent) : [];
    } catch (e) {
      return [];
    }
  }

  function saveSearch(query) {
    if (!query) return;
    var maxRecent = 3;
    var recent = getRecentSearches();
    var index = recent.indexOf(query);
    if (index > -1) {
      recent.splice(index, 1);
    }
    recent.unshift(query);
    if (recent.length > maxRecent) {
      recent = recent.slice(0, maxRecent);
    }
    localStorage.setItem('recentSearches', JSON.stringify(recent));
  }

  function renderRecentSearches() {
    var recent = getRecentSearches();
    var container = results.querySelector('.search-popup__recent-tags');
    var section = results.querySelector('.search-popup__recent');
    if (section) {
      section.style.setProperty('display', 'block', 'important');
    }
    if (!container) return;
    
    container.innerHTML = '';
    if (recent.length > 0) {
      recent.forEach(function(term) {
        var tag = document.createElement('a');
        tag.href = '/search?q=' + encodeURIComponent(term + '*') + '&type=product&options[prefix]=last';
        tag.className = 'search-popup__tag';
        tag.textContent = term;
        tag.addEventListener('click', function() {
          saveSearch(term);
        });
        container.appendChild(tag);
      });
    }
  }

  function updateHeaderBottom() {
    var header = document.querySelector('.site-header');
    if (header && popup.classList.contains('is-open')) {
      var rect = header.getBoundingClientRect();
      popup.style.setProperty('--header-bottom', rect.bottom + 'px');
    }
  }

  /* ---- Open / close ---- */
  function openPopup() {
    popup.classList.add('is-open');
    popup.removeAttribute('aria-hidden');
    document.body.classList.add('search-popup-open');
    document.documentElement.classList.add('search-popup-open');
    var header = document.querySelector('.site-header');
    if (header) header.classList.add('is-search-open');
    updateHeaderBottom();
    renderRecentSearches();
    toggleClearAndCloseButtons();
    setTimeout(function () { input.focus(); }, 50);
  }

  function closePopup() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('search-popup-open');
    document.documentElement.classList.remove('search-popup-open');
    var header = document.querySelector('.site-header');
    if (header) header.classList.remove('is-search-open');
    
    // Clear search data after transition completes (250ms)
    setTimeout(function () {
      if (!popup.classList.contains('is-open')) {
        input.value = '';
        currentQuery = '';
        results.innerHTML = defaultRecentHTML;
        renderRecentSearches();
        toggleClearAndCloseButtons();
      }
    }, 250);
  }

  if (openBtn)  openBtn.addEventListener('click', openPopup);
  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (overlay)  overlay.addEventListener('click', closePopup);

  window.addEventListener('scroll', updateHeaderBottom, { passive: true });
  window.addEventListener('resize', updateHeaderBottom, { passive: true });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
  });

  /* ---- Navigate to search page ---- */
  function goToSearch() {
    var q = input.value.trim();
    if (!q) return;
    saveSearch(q);
    window.location.href = '/search?q=' + encodeURIComponent(q + '*') + '&type=product&options[prefix]=last';
  }

  if (submit) submit.addEventListener('click', goToSearch);

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') goToSearch();
  });

  // Track click on predictive search results to save search
  results.addEventListener('click', function(e) {
    var searchProductLink = e.target.closest('.product-card');
    if (searchProductLink) {
      var q = input.value.trim();
      saveSearch(q);
    }
  });

  // Toggle clear icon inside input and close button label ("Kembali" vs "Batal")
  function toggleClearAndCloseButtons() {
    var q = input.value.trim();
    var hasText = q.length > 0;
    
    if (clearBtn) {
      clearBtn.style.display = hasText ? 'flex' : 'none';
    }
    
    if (closeLabel) {
      var isMobile = window.innerWidth < 768;
      if (isMobile) {
        closeLabel.textContent = hasText ? 'Batal' : 'Kembali';
      }
    }
  }

  // Clear button click listener
  if (clearBtn) {
    clearBtn.addEventListener('click', function() {
      input.value = '';
      currentQuery = '';
      results.innerHTML = defaultRecentHTML;
      renderRecentSearches();
      toggleClearAndCloseButtons();
      input.focus();
    });
  }

  /* ---- Predictive search ---- */
  input.addEventListener('input', function () {
    var q = input.value.trim();
    
    toggleClearAndCloseButtons();

    clearTimeout(debounceTimer);

    if (q.length < 3) {
      results.innerHTML = q.length > 0
        ? '<p class="search-popup__hint">Type at least 3 characters…</p>'
        : defaultRecentHTML;
      if (q.length === 0) {
        renderRecentSearches();
      }
      return;
    }

    if (q === currentQuery) return;

    debounceTimer = setTimeout(function () {
      fetchPredictions(q);
    }, 300);
  });

  function fetchPredictions(q) {
    currentQuery = q;
    showLoading();

    var isMobile = window.innerWidth < 768;
    var limit = isMobile ? 4 : 6;

    // Use Shopify Predictive Search HTML API with section_id rendering
    var url = '/search/suggest'
      + '?q=' + encodeURIComponent(q)
      + '&resources[type]=product'
      + '&resources[limit]=' + limit
      + '&resources[options][unavailable_products]=show'
      + '&section_id=predictive-search';

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('Network error');
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var sectionContent = doc.getElementById('shopify-section-predictive-search');
        
        if (sectionContent && sectionContent.innerHTML.trim().length > 0) {
          results.innerHTML = sectionContent.innerHTML;
        } else {
          // Fallback if section structure differs
          results.innerHTML = html;
        }
        
        // Trigger swatch responsiveness updates for the newly inserted search result cards
        document.dispatchEvent(new CustomEvent('shopify:section:load'));
      })
      .catch(function () {
        results.innerHTML = '<p class="search-popup__hint">Something went wrong. Try again.</p>';
      });
  }

  function showLoading() {
    results.innerHTML = '<div class="search-popup__loading">'
      + '<span class="search-popup__spinner"></span>'
      + '<span>Searching…</span>'
      + '</div>';
  }
})();
